<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Export Planogram PDF</h4>
  <button
    type="button"
    class="btn btn-link p-0 border-0"
    aria-label="Close"
    (click)="cancel()"
  >
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <!-- General Settings Section -->
  <div class="card mb-3">
    <div class="card-header">
      <h5 class="mb-0">General Settings</h5>
    </div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-auto d-flex align-items-center">
          <label for="title">Title</label>
        </div>
        <div class="col d-flex align-items-center">
          <input
            type="text"
            class="form-control"
            id="title"
            [(ngModel)]="title"
            placeholder="Enter title"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-auto d-flex align-items-center">
          <label for="subtitle">Subtitle</label>
        </div>
        <div class="col d-flex align-items-center">
          <input
            type="text"
            class="form-control"
            id="subtitle"
            [(ngModel)]="subtitle"
            placeholder="Enter subtitle"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-auto d-flex align-items-center">
          <label>Top Left Logo</label>
        </div>
        <div class="col">
          <select class="form-select" [(ngModel)]="topLeftLogo">
            <option value="" selected>N/A</option>
            <option *ngFor="let logo of logos" [value]="logo.name">
              {{ logo.name }}
            </option>
          </select>
        </div>
        <div class="col-auto d-flex align-items-center">
          <label>Top Right Logo</label>
        </div>
        <div class="col">
          <select class="form-select" [(ngModel)]="topRightLogo">
            <option value="" selected>N/A</option>
            <option *ngFor="let logo of logos" [value]="logo.name">
              {{ logo.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="row mb-2" *ngIf="featuresService.isEnabled('OnQR') | async">
        <div class="col offset-md-0 d-flex align-items-center">
          <div class="form-check me-3">
            <input
              class="form-check-input"
              type="checkbox"
              id="includeQRCode"
              [(ngModel)]="includeQRCode"
            />
            <label class="form-check-label" for="includeQRCode">
              Include QR Code to OnQR Portal
            </label>
          </div>
          <button type="button" class="btn btn-link btn-sm p-0" title="Download QR Code Image" (click)="downloadQrCode()">
            <i class="bi bi-download"></i> Download QR Image
          </button>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-auto d-flex align-items-center">
          <label for="maxDropsPerPage">Maximum Drops per page</label>
        </div>
        <div class="col d-flex align-items-center">
          <input
            type="number"
            class="form-control"
            id="maxDropsPerPage"
            [(ngModel)]="maxDropsPerPage"
            min="1"
            max="5"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-auto d-flex align-items-center">
          <label for="alignShelvesAcrossDrops"
            >Align Shelves Across Drops</label
          >
        </div>
        <div class="col d-flex align-items-center">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="alignShelvesAcrossDrops"
              [(ngModel)]="alignShelvesAcrossDrops"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-auto d-flex align-items-center">
          <label for="includeNationalId">Include NationalId</label>
        </div>
        <div class="col d-flex align-items-center">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="includeNationalId"
              [(ngModel)]="includeNationalId"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-auto d-flex align-items-center">
          <label for="limitDepthByDOS">Limit Depth by DOS</label>
        </div>
        <div class="col d-flex align-items-center">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="limitDepthByDOS"
              [(ngModel)]="limitDepthByDOS"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Reports Section -->
  <div class="card mb-3">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Reports to Include</h5>
      <button class="btn btn-sm btn-secondary" (click)="toggleAllReports()">
        {{ areAllReportsSelected() ? "Deselect All" : "Select All" }}
      </button>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="dropAnalysis"
              id="dropAnalysis"
            />
            <label class="form-check-label" for="dropAnalysis">
              Drop Analysis
            </label>
          </div>
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="manufacturerReport"
              id="manufacturerReport"
            />
            <label class="form-check-label" for="manufacturerReport">
              Manufacturer Report
            </label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="brandReport"
              id="brandReport"
            />
            <label class="form-check-label" for="brandReport">
              Brand Report
            </label>
          </div>
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="segmentReport"
              id="segmentReport"
            />
            <label class="form-check-label" for="segmentReport">
              Segment Report
            </label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="segmentBreakdownReport"
              id="segmentBreakdownReport"
            />
            <label class="form-check-label" for="segmentBreakdownReport">
              Segment Breakdown Report
            </label>
          </div>
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="top15ProductsReport"
              id="top15ProductsReport"
            />
            <label class="form-check-label" for="top15ProductsReport">
              Top 15 Products Report
            </label>
          </div>
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="floatingShelf"
              id="floatingShelf"
            />
            <label class="form-check-label" for="floatingShelf">
              Floating Shelf
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="confirm()">
    Export
  </button>
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
